import { Flex } from '@mantine/core';
import { useEffect, useMemo } from 'react';
import { StepCard } from 'src/UI/generate-flow/StepCard';
import { useClients } from 'src/clients/hooks/useClients';
import { Client } from 'src/admin/users/types';
import { ClientList, ClientListItem } from 'src/UI/generate-flow/ClientList';
import { MeetingNoteStepProps } from '../types';

type Props = MeetingNoteStepProps & {
  preselectClientId?: string;
};

export function NoteClientStep({ data, setData, filter, preselectClientId }: Props) {
  const { clients } = useClients();
  const term = (filter ?? '').trim().toLowerCase();

  const clientItems: ClientListItem[] = useMemo(() => {
    const base: ClientListItem[] = clients.map(c => ({ client: c }));

    base.sort((a, b) => {
      if (preselectClientId) {
        if (a.client.id === preselectClientId) return -1;
        if (b.client.id === preselectClientId) return 1;
      }
      return a.client.lastName.localeCompare(b.client.lastName);
    });

    if (!term) return base;
    return base.filter(({ client }) => {
      const first = client.firstName.toLowerCase();
      const last = client.lastName.toLowerCase();
      const email = (client.emailAddress ?? '').toLowerCase();
      return first.includes(term) || last.includes(term) || email.includes(term);
    });
  }, [clients, term, preselectClientId]);

  useEffect(() => {
    if (data.client?.id) return;
    if (!preselectClientId) return;
    const match = clients.find(c => c.id === preselectClientId);
    if (!match) return;
    setData(prev => ({ ...prev, client: match }));
  }, [clients, data.client?.id, preselectClientId, setData]);

  return (
    <Flex direction="column" h="100%" mih={0}>
      <StepCard title="Select the client to generate meeting note">
        <ClientList
          items={clientItems}
          selectedClientId={data.client?.id}
          onSelect={(client: Client) => setData(prev => ({ ...prev, client }))}
        />
      </StepCard>
    </Flex>
  );
}
